import React, { useState, useEffect } from "react";
import CryptoJS from "crypto-js";

import { dateFormatter } from "../../hooks/HelperFunctions";

import Grid from "@mui/material/Grid";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import Buttons from "../Button/Button";
import ModalTwo from "../Modals/ModalTwo";
import ShareThisCourse from "../ShareThisCourse/ShareThisCourse";
import CustomizedSnackbar from "../../hooks/Snackbar";

import styles from "../Session/Session.module.css";
import Image from "next/image";
import Link from "next/link";
import { useShoppingCart } from "../../contexts/CartContext";
import SideDrawer from "../../pages/Payments/compononents/SideDrawer/SideDrawer";
import ShoppingCart from "../../pages/Payments/forms/ShoppingCart";
import CheckIcon from "@mui/icons-material/Check";
import moment from "moment-timezone";
import ModalsResponsiveFullScreen from "../Modals/ModalsResponsiveFullScreen";
import { DiplomaIcon } from "../../assets/icons/DiplomaIcon";
import { StreamingIcon } from "../../assets/icons/StreamingIcon";
import { useSelector } from "react-redux";
import { PlayIcon } from "../../assets/icons/PlayIcon";
import { Modal, Box, IconButton } from "@mui/material";
import { MediaPlayer, MediaProvider } from "@vidstack/react";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import {
  defaultLayoutIcons,
  DefaultVideoLayout,
} from "@vidstack/react/player/layouts/default";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";

function SearchedCourse(props) {
  const {
    courses,
    setUpdateCart,
    cardBtn,
    enrollNowHandler,
    setOpenSignUpModel,
  } = props;

  const activeCurrency = useSelector((state) => state.currency.activeCurrency);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [previewLink, setPreviewLink] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [addToCartBtnLink, setAddToCartBtnLink] = useState(false);
  const [addToCartBtnLabel, setAddToCartBtnLabel] = useState({});
  const [addToCartBtnLabelForGoToCourse, setAddToCartBtnLabelForGoToCourse] =
    useState({});
  const [userData, setUserData] = useState([]);
  const [deleteMedia, setDeleteMedia] = useState(false);
  const [mediaData, setMediaData] = useState({});
  useEffect(() => {
    setUserData(JSON.parse(localStorage.getItem("userData")));
  }, []);
  const { cartItems, setCartItems, cartItemsCoupons, setCartItemsCoupons } =
    useShoppingCart();
  // ====== Payment Drawer Start======//
  const [openShoppingDrawer, setOpenShoppingDrawer] = useState(false);
  const handleOpenShoppingDrawer = () => {
    setOpenShoppingDrawer(true);
  };
  const CloseShoppingDrawer = () => {
    setOpenShoppingDrawer(false);
  };
  // ====== Payment Drawer End======//

  /**
   * When click on snackbar close btn
   */
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setShowSnackbar(false);
  };

  const [currentCourseData, setCurrentCourseData] = useState({});

  const [cartCourse, setCartCourse] = useState(() => {
    if (typeof window !== "undefined") {
      const localData = JSON.parse(localStorage.getItem("selectedCourses"));
      if (localData) {
        return localData;
      } else {
        return [];
      }
    } else {
      return [];
    }
  });

  const [maxCoursesShow, setMaxCoursesShow] = useState(6);

  // max courses array size
  const coursesArrSize = courses.length;
  // course card data
  let courseCards = courses;
  if (maxCoursesShow == 6) {
    courseCards = courses.slice(0, 6);
  }

  // show/hide show all btn
  let showAllBtnStatus = true;
  if (coursesArrSize <= 6 || courses.length == courseCards.length) {
    showAllBtnStatus = false;
  }

  const showAllBtnHandler = () => {
    setMaxCoursesShow(999);
  };

  useEffect(() => {
    localStorage.setItem("selectedCourses", JSON.stringify(cartCourse));
    if (typeof setUpdateCart === "function") {
      setUpdateCart(true);
    }
  }, [cartCourse]);

  // useEffect(() => {
  //   const localCourses = JSON.parse(localStorage.getItem("selectedCourses"));

  //   if (localCourses) {
  //     localCourses.forEach((item) => {
  //       let updateAddToCartLabel = {};
  //       updateAddToCartLabel[item.courseId] = "Go to cart";

  //       setAddToCartBtnLabel((addToCartBtnLabel) => ({
  //         ...addToCartBtnLabel,
  //         ...updateAddToCartLabel,
  //       }));
  //     });
  //   }
  // }, []);
  useEffect(() => {
    if (cartItems) {
      const updatedLabels = {};
      cartItems?.map((item) => {
        updatedLabels[item?.courseId] = "Go to cart";
      });
      setAddToCartBtnLabel(updatedLabels);
    }
  }, [cartItems]);

  useEffect(() => {
    const interval = setInterval(() => {
      // call alrady enrolled course data process function
      const userAuthenticated = localStorage.getItem("userAuthenticated");
      if (userAuthenticated) {
        updateAlreadyEnrolledCourseList();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const updateAlreadyEnrolledCourseList = () => {
    const alreadyEnrolledCourses = JSON.parse(
      localStorage.getItem("alreadyEnrolledCourses"),
    );

    if (alreadyEnrolledCourses) {
      alreadyEnrolledCourses?.forEach((item) => {
        let updateAddToCartLabel = {};
        updateAddToCartLabel[item.courseId] = "Go to Course";

        setAddToCartBtnLabelForGoToCourse((addToCartBtnLabelForGoToCourse) => ({
          ...addToCartBtnLabelForGoToCourse,
          ...updateAddToCartLabel,
        }));
      });
    }
  };

  const addToCartHandler = (item) => {
    let userInfo = JSON.parse(localStorage.getItem("userData"));
    if (addToCartBtnLabel[item.courseId]) {
      // var base_url = window.location.origin;
      // window.location.href = base_url + "/shopping";
      handleOpenShoppingDrawer();
    } else {
      setAddToCartBtnLink(true);

      let updateAddToCartLabel = {};
      updateAddToCartLabel[item.courseId] = "Go to cart";

      const cartPaymentInfo = JSON.parse(
        localStorage.getItem("cartPaymentInfo"),
      );

      let found = 0;

      //this section search course already exists in a cart or not. if exists it increase the found
      cartPaymentInfo?.map((singleCartitem) => {
        if (singleCartitem?.courses && singleCartitem?.courses?.length > 0) {
          singleCartitem?.courses?.map((course) => {
            if (course?.course?.courseId == item?.courseId) {
              found++;
            }
          });
        }
      });

      if (found > 0) {
        setShowSnackbar(true);
        setSnackbarSeverity("error");
        setSnackbarMessage("Course already added to a track.");
        return false;
      }

      let independentCourseIdsWithCoupons = null;

      if (cartItemsCoupons?.length > 0) {
        let found = cartItemsCoupons?.find(
          (single) => single.courseId == item?.courseId,
        );
        if (found) {
          let addedItemsCoupons = item?.active_coupons
            ?.filter(
              (coupon) =>
                coupon.apply_automatically === true &&
                (coupon.applies_for === "everyone" ||
                  (coupon.applies_for === "selected_users" &&
                    userInfo?.id &&
                    Array.isArray(coupon.user_ids) &&
                    coupon.user_ids.includes(userInfo.id))),
            )
            .map((coupon) => coupon.id);

          let uniqueCouponIds = [
            ...new Set([...found?.couponIds, ...addedItemsCoupons]),
          ];

          independentCourseIdsWithCoupons = {
            courseId: item?.courseId,
            couponIds: uniqueCouponIds,
          };
        } else {
          let addedItemsCoupons = item?.active_coupons
            ?.filter(
              (coupon) =>
                coupon?.apply_automatically === true &&
                (coupon.applies_for === "everyone" ||
                  (coupon.applies_for === "selected_users" &&
                    userInfo?.id &&
                    Array.isArray(coupon.user_ids) &&
                    coupon.user_ids.includes(userInfo.id))),
            )
            .map((coupon) => coupon.id);

          independentCourseIdsWithCoupons = {
            courseId: item?.courseId,
            couponIds: addedItemsCoupons,
          };
        }
      } else {
        let addedItemsCoupons = item?.active_coupons
          ?.filter(
            (coupon) =>
              coupon.apply_automatically === true &&
              (coupon.applies_for === "everyone" ||
                (coupon.applies_for === "selected_users" &&
                  userInfo?.id &&
                  Array.isArray(coupon.user_ids) &&
                  coupon.user_ids.includes(userInfo.id))),
          )
          .map((coupon) => coupon.id);

        independentCourseIdsWithCoupons = {
          courseId: item?.courseId,
          couponIds: addedItemsCoupons,
        };
      }

      setAddToCartBtnLabel((addToCartBtnLabel) => ({
        ...addToCartBtnLabel,
        ...updateAddToCartLabel,
      }));

      console.log(courses, cartItems, "courses something");

      const updatedSelectedCourses = cartItems.map((selected) => {
        const updated = courses.find(
          (course) => course.courseId === selected.courseId,
        );
        return updated || selected;
      });

      setCartItems([item, ...updatedSelectedCourses]);
      setCartCourse([...cartCourse, item]);
      if (independentCourseIdsWithCoupons?.couponIds?.length > 0) {
        setCartItemsCoupons([
          ...cartItemsCoupons,
          independentCourseIdsWithCoupons,
        ]);
      }

      setUpdateCart(true);
      setShowSnackbar(true);
      setSnackbarSeverity("success");
      setSnackbarMessage("Course added to the cart.");
      localStorage.setItem(
        "cartPaymentInfo",
        JSON.stringify([item, ...updatedSelectedCourses]),
      );
      if (independentCourseIdsWithCoupons?.couponIds?.length > 0) {
        localStorage.setItem(
          "itemsCoupons",
          JSON.stringify([
            independentCourseIdsWithCoupons,
            ...cartItemsCoupons,
          ]),
        );
      }
    }
  };

  const [open, setOpen] = React.useState(false);

  const handleOpen = (item) => {
    setCurrentCourseData(item);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const gotoCourseDetails = (courseId) => {
    // redirect to portal's auto sign in page
    const portalUrl =
      process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
        ? process.env.NEXT_PUBLIC_PORTAL_URL_PROD
        : process.env.NEXT_PUBLIC_PORTAL_URL_DEV;
    const userToken = localStorage.getItem("userToken");
    const tokenData = { email: userData.email, userToken: userToken };
    var token = CryptoJS.AES.encrypt(
      JSON.stringify([tokenData]),
      "login-854256-secret-key",
    ).toString();
    console.log(token);
    if (typeof window !== "undefined") {
      const path = `&courseDetailId=${courseId}`;
      window.location.replace(`/course-details-learner/${courseId}`);
      // window.location.replace(
      //   `${portalUrl}/token-based-signin?token=${token}${path}`
      // );
    }
  };
  const today = moment();

  const getAddToCartToolTip = (course) => {
    const enrollmentStartDate = new Date(course.enrollmentStartDate);
    // For pre-recorded courses, enrollmentEndDate is optional - only check if it exists
    const enrollmentEndDate = course.enrollmentEndDate
      ? new Date(course.enrollmentEndDate)
      : null;
    if (
      addToCartBtnLabel[course.courseId] != "Go to cart" &&
      course.seatsStatus &&
      course.seats &&
      course.totalEnrolled >= course.seats
    ) {
      return "The course has reached its maximum enrollment capacity";
    } else if (today < enrollmentStartDate) {
      // Options for formatting the date
      const options = { year: "numeric", month: "short", day: "numeric" };

      // Format the date
      const formattedDate = enrollmentStartDate.toLocaleDateString(
        "en-US",
        options,
      );

      return `Enrollment starts on ${formattedDate}`;
    } else if (enrollmentEndDate && today > enrollmentEndDate) {
      // Only check enrollment end date if it exists (for live courses or pre-recorded with end date)
      // Options for formatting the date
      const options = { year: "numeric", month: "short", day: "numeric" };

      // Format the date
      const formattedDate = enrollmentEndDate.toLocaleDateString(
        "en-US",
        options,
      );

      return `Enrollment closed on ${formattedDate}`;
    } else {
      return "";
    }
  };

  const isItOnLiveNow = (sessionStartTimes, sessionEndTimes) => {
    // Get current time
    const now = new Date();

    let isLive = false;

    for (let i = 0; i < sessionStartTimes.length; i++) {
      const start = new Date(sessionStartTimes[i]);
      const end = new Date(sessionEndTimes[i]);
      if (now >= start && now <= end) {
        isLive = true;
        break;
      }
    }
    return isLive;
  };

  const CURRENCY_SIGNS = {
    USD: "$",
    EUR: "€",
    GBP: "£",
  };

  const getTheCorrectCurrencySign = () => {
    return CURRENCY_SIGNS[activeCurrency] ?? "$";
  };

  const showSessionStartDate = (item) => {
    if (!item?.sessionStartDate) return null;

    return (
      <>
        Starts:{" "}
        {dateFormatter(
          item.sessionStartDate,
          item.timezone,
          "ddd, MMM D z",
        )}{" "}
      </>
    );
  };

  return (
    <div>
      <Grid container spacing={2}>
        {courses.map((item, i) => {
          const preview = item?.courseModules
            ?.flatMap((module) => module?.courseSessions || [])
            ?.find(
              (session) =>
                session?.allowUserToPreview === 1 &&
                session?.isPrerecorded === 1,
            )?.prerercordedVideo;
          const singleSession = item?.courseModules
            ?.flatMap((module) => module?.courseSessions || [])
            ?.find(
              (session) =>
                session?.allowUserToPreview === 1 &&
                session?.isPrerecorded === 1,
            );

          return (
            <Grid item xs={12} sm={12} md={props.col}>
              <div className={styles.SessionCard}>
                <div
                  className={`${styles.SessionCardImg} ${styles.searchedCardImg}`}
                >
                  {item?.courseFormat == "live" &&
                    item?.sessionStartTimes?.length > 0 && (
                      <span
                        className={styles.StatusOne}
                        style={{ display: "flex" }}
                      >
                        {isItOnLiveNow(
                          item?.sessionStartTimes,
                          item?.sessionEndTimes,
                        ) ? (
                          <>
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginRight: "4px",
                              }}
                            >
                              <StreamingIcon />
                            </span>
                            STREAMING NOW
                          </>
                        ) : (
                          "LIVE"
                        )}
                      </span>
                    )}

                  {/* {item.courseStreamingStatus == "" ? (
                  ""
                ) : (
                  <span className={styles.StatusTwo}>
                    {" "}
                    {item.courseStreamingStatus}{" "}
                  </span>
                )} */}
                  <div className={styles.CourseCardImageBox}>
                    {preview && (
                      <button
                        className={styles.CardPlayIcon}
                        onClick={() => {
                          setPreviewLink(preview);
                          setMediaData(singleSession);
                          setDeleteMedia(true);
                        }}
                      >
                        <PlayIcon />
                      </button>
                    )}

                    <Link href={item.detailLink}>
                      {item.courseImage ? (
                        <div>
                          <img
                            src={item.courseImage}
                            className="courseCardImg"
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                    </Link>
                  </div>
                </div>
                {/* {props.Diploma &&
              <div className={styles.SessionCardDiplomaSection}><DiplomaIcon /> {props.Diploma}</div>
            } */}

                <div className={styles.SessionCardInfo}>
                  <div className={styles.SessionCardDate}>
                    <h3>
                      {item.sessionEndDate &&
                      today?.isAfter(moment(item.sessionEndDate)) ? (
                        <>
                          <CheckIcon />
                          Completed:{" "}
                          {dateFormatter(
                            item.sessionEndDate,
                            item.timezone,
                            "MMM D, YYYY",
                          )}
                        </>
                      ) : (
                        (!item.enrollmentEndDate ||
                          today?.isBefore(moment(item?.enrollmentEndDate))) &&
                        showSessionStartDate(item)
                      )}
                    </h3>
                    {(!item.enrollmentEndDate ||
                      today?.isBefore(moment(item.enrollmentEndDate))) && (
                      <span data-id={item.price == "Free" ? 0 : item.price}>
                        {item.price == "Free"
                          ? "Free"
                          : getTheCorrectCurrencySign() + item.price}
                      </span>
                    )}
                  </div>
                  <div className={styles.TitleContainer}>
                    <h1>
                      <Link href={item.detailLink}>{item.courseTitle}</Link>
                    </h1>
                    {/* <p>{Object.keys(item.instructors).map(function (k) { return item.instructors[k]['instructorName'] }).join(", ")}</p> */}
                    <p>{item.leadInstructor}</p>
                  </div>
                  {item.courseCardBtn != "hide" ? (
                    <>
                      <div
                        className={`${styles.SessionCardFooter} ${"ButtonGroup"}`}
                      >
                        <div className={styles.ButtonContainer}>
                          {addToCartBtnLabelForGoToCourse[item.courseId] ==
                          "Go to Course" ? (
                            <Buttons
                              tooltip={
                                addToCartBtnLabelForGoToCourse[item.courseId] !=
                                  "Go to Course" &&
                                item.seatsStatus &&
                                item.seats &&
                                item.totalEnrolled >= item.seats
                                  ? "The course has reached its maximum enrollment capacity"
                                  : ""
                              }
                              label={
                                addToCartBtnLabelForGoToCourse[item.courseId]
                                  ? "Go to Course"
                                  : ""
                              }
                              buttonColor={
                                addToCartBtnLabelForGoToCourse[item.courseId]
                                  ? addToCartBtnLabelForGoToCourse[
                                      item.courseId
                                    ] == "Go to Course"
                                    ? "#0b9444"
                                    : "#ffffff"
                                  : "#004FE0"
                              }
                              color={"#fff"}
                              border={""}
                              width="100%"
                              height="48px"
                              fontSize="14px"
                              disabled={
                                item.courseCardBtn == "disabled" ||
                                (addToCartBtnLabelForGoToCourse[
                                  item.courseId
                                ] != "Go to Course" &&
                                  item.seatsStatus &&
                                  item.seats &&
                                  item.totalEnrolled >= item.seats)
                                  ? item.courseCardBtn
                                  : ""
                              }
                              // link={addToCartBtnLabel[item.courseId] == "Go to Course"? `${portalBaseUrl}/my-course-details/${item.courseId}` : ""}
                              onClick={() => gotoCourseDetails(item.courseId)}
                            />
                          ) : (
                            <Buttons
                              // tooltip={
                              //   item.seats && item.totalEnrolled >= item.seats
                              //     ? "The course has reached its maximum enrollment capacity"
                              //     : ""
                              // }
                              // tooltip={"alter"}
                              tooltip={getAddToCartToolTip(item)}
                              label={
                                addToCartBtnLabel[item.courseId]
                                  ? addToCartBtnLabel[item.courseId]
                                  : item.price == "Free"
                                    ? "Enroll for Free"
                                    : "Add to cart"
                              }
                              buttonColor={
                                addToCartBtnLabel[item.courseId]
                                  ? addToCartBtnLabel[item.courseId] ==
                                    "Go to Course"
                                    ? "#0b9444"
                                    : "#ffffff"
                                  : "#004FE0"
                              }
                              color={
                                addToCartBtnLabel[item.courseId] == "Go to cart"
                                  ? "#004FE0"
                                  : "#fff"
                              }
                              border={
                                addToCartBtnLabel[item.courseId] == "Go to cart"
                                  ? "1px solid #676C7B"
                                  : ""
                              }
                              width="100%"
                              height="48px"
                              fontSize="14px"
                              disabled={
                                item.courseCardBtn == "disabled" ||
                                (addToCartBtnLabel[item.courseId] !=
                                  "Go to cart" &&
                                  item.seatsStatus &&
                                  item.seats &&
                                  item.totalEnrolled >= item.seats)
                                  ? item.courseCardBtn
                                  : ""
                              }
                              // link={addToCartBtnLabel[item.courseId] == "Go to Course"? `${portalBaseUrl}/my-course-details/${item.courseId}` : ""}
                              onClick={
                                addToCartBtnLabel[item.courseId] ==
                                "Go to Course"
                                  ? () => gotoCourseDetails(item.courseId)
                                  : item.price == "Free"
                                    ? () => enrollNowHandler(item)
                                    : () => addToCartHandler(item, i)
                              }
                            />
                          )}
                        </div>

                        <div className={styles.ShareButton}>
                          <div className={styles.ButtonContainer}>
                            <Buttons
                              icon={<ShareRoundedIcon />}
                              buttonColor="#fff"
                              color="#004FE0"
                              width="48px"
                              height="48px"
                              fontSize="30px"
                              borderRadius="10px"
                              border="#004FE0 2px solid"
                              onClick={() => handleOpen(item)}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {/* {item.courseCardBtn != "hide" ? (
                  <>
                    <div
                      className={`${styles.SessionCardFooter} ${"ButtonGroup"}`}
                    >
                      <div className={styles.ButtonContainer}>
                        <Buttons
                          label={
                            addToCartBtnLabel[item.courseId]
                              ? addToCartBtnLabel[item.courseId]
                              : item.price == "Free"
                              ? "Enroll for Free"
                              : "Add to cart"
                          }
                          buttonColor={
                            addToCartBtnLabel[item.courseId]
                              ? addToCartBtnLabel[item.courseId] ==
                                "Go to Course"
                                ? "#0b9444"
                                : "#ffffff"
                              : "#004FE0"
                          }
                          color={
                            addToCartBtnLabel[item.courseId] == "Go to cart"
                              ? "#004FE0"
                              : "#fff"
                          }
                          border={
                            addToCartBtnLabel[item.courseId] == "Go to cart"
                              ? "2px solid #bcbcbc"
                              : ""
                          }
                          width="100%"
                          height="48px"
                          fontSize="14px"
                          disabled={
                            item.courseCardBtn == "disabled"
                              ? item.courseCardBtn
                              : ""
                          }
                          // link={addToCartBtnLabel[item.courseId] == "Go to Course"? `${portalBaseUrl}/my-course-details/${item.courseId}` : ""}
                          onClick={
                            addToCartBtnLabel[item.courseId] == "Go to Course"
                              ? () => gotoCourseDetails(item.courseId)
                              : item.price == "Free"
                              ? () => enrollNowHandler(item)
                              : () => addToCartHandler(item, i)
                          }
                        />
                      </div>

                      <div className={styles.ShareButton}>
                        <div className={styles.ButtonContainer}>
                          <Buttons
                            icon={<ShareRoundedIcon />}
                            buttonColor="#fff"
                            color="#676C7B"
                            width="48px"
                            height="48px"
                            fontSize="30px"
                            borderRadius="100px"
                            border="#676C7B 1px solid"
                            onClick={() => handleOpen(item)}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )} */}
                </div>
              </div>
            </Grid>
          );
        })}
      </Grid>

      <ModalsResponsiveFullScreen
        open={open}
        handleClose={handleClose}
        width="552px"
        ModalTitle="Share this course"
        titileColor="#33B651"
        padding="20px"
        body={
          <div className="ModalSocialShare">
            <ShareThisCourse course={currentCourseData} showTitle={false} />
          </div>
        }
      />

      <CustomizedSnackbar
        open={showSnackbar}
        severity={snackbarSeverity}
        message={snackbarMessage}
        handleClose={handleSnackbarClose}
      />
      {/* === Shopping Cart Drawer Start*/}
      <SideDrawer
        drawerWidth="744px"
        padding="24px"
        title={`Shopping Cart (${cartItems?.length} Item${
          cartItems?.length > 1 ? "s" : ""
        })`}
        sideOpen="right"
        open={openShoppingDrawer}
        handleDrawerClose={CloseShoppingDrawer}
        Headerbackground="#004FE0"
        HeaderTextColor="#fff"
        body={<ShoppingCart setOpenSignUpModel={setOpenSignUpModel} />}
      />
      {/* === Shopping Cart Drawer End*/}

      {/*** ================== MediaPlayer  player added ==========================***/}
      <Modal
        open={deleteMedia && previewLink !== ""}
        onClose={() => setDeleteMedia(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            height: "auto",
            width: "600px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "black",
            boxShadow: 24,
            position: "relative",
          }}
        >
          <IconButton
            onClick={() => setDeleteMedia(false)}
            sx={{
              padding: 0,
              position: "absolute !important",
              top: "-6px",
              right: "-44px",
              color: "#fff",
              zIndex: 999,
              borderRadius: "50%",
              "&.MuiButtonBase-root": {
                position: "absolute !important",
              },
            }}
          >
            <CloseRoundedIcon
              fontSize="large"
              sx={{
                color: "#fff",
              }}
            />
          </IconButton>

          <MediaPlayer
            title={mediaData?.title}
            src={previewLink}
            autoPlay
            muted
          >
            <MediaProvider />
            <DefaultVideoLayout thumbnails={null} icons={defaultLayoutIcons} />
          </MediaPlayer>
        </Box>
      </Modal>
      {/*** ================== MediaPlayer  player added ==========================***/}
    </div>
  );
}

export default SearchedCourse;
